var $4603b0d0246969b2$exports = {};
$4603b0d0246969b2$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " - ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " se\xE7ildi");
  },
  "finishRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xE7imini tamamlamak i\xE7in t\u0131klay\u0131n",
  "maximumDate": "Son m\xFCsait tarih",
  "minimumDate": "\u0130lk m\xFCsait tarih",
  "next": "Sonraki",
  "previous": "\xD6nceki",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Se\xE7ilen Tarih: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Se\xE7ilen Aral\u0131k: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Tarih aral\u0131\u011F\u0131 se\xE7imini ba\u015Flatmak i\xE7in t\u0131klay\u0131n",
  "todayDate": function todayDate(args) {
    return "Bug\xFCn, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Bug\xFCn, ".concat(args.date, " se\xE7ildi");
  }
};
export { $4603b0d0246969b2$exports as default };